import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DietitianState,
  DietitianStateProvider,
} from 'src/app/data/dietitian/domain/dietitian_state_provider';
import { PatientGroupEventProvider } from 'src/app/data/dietitian/domain/events/patient_group_event_provider';
import { PatientGroupEvent } from 'src/app/data/dietitian/domain/events/patient_group_events';
import { PatientGroup } from 'src/app/data/dietitian/domain/patient_group/patient_group';
import { PatientGroupCommands } from 'src/app/data/dietitian/domain/patient_group/patient_group_commands';

@Injectable()
export class PatientGroupListFacade {
  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private patientGroupEventProvider: PatientGroupEventProvider,
    private patientGroupCommands: PatientGroupCommands,
  ) {
    // do nothing
  }

  get dietitianState$(): Observable<DietitianState> {
    return this.dietitianStateProvider.state$;
  }

  get patientGroupEvents$(): Observable<PatientGroupEvent> {
    return this.patientGroupEventProvider.events$;
  }

  getDietitianPatientGroups(dietitianId: string): Promise<PatientGroup[]> {
    return this.patientGroupCommands.getDietitianPatientGroups(dietitianId);
  }
}
